export default __webpack_public_path__ + "static/media/simplified-shipping.74d60ab8.svg";